import React from 'react';
import { Divider, Stack } from '@mui/material';
import Pagination from '../../../components/common/Pagination';
import ProgressBar from '../../../components/common/ProgressBar';
import { useActivityData } from '../../../hooks/useActivityData';
import theme from '../../../theme';
import NoData from '../../../components/common/NoData';

const ActivityTab = ({
  api,
  userId,
  ItemComponent,
  itemKey,
  adminMode = false,
  readOnly = false,
  includeItem,
}) => {
  const { data, loading, totalCount, page, pageCount, handlePageChange, handleItemDelete } =
    useActivityData(api, userId, includeItem);

  return (
    <ProgressBar isLoading={loading}>
      <Stack spacing={{ xs: '15px', md: '10px' }}>
        {data.map((item, index) => (
          <React.Fragment
            key={`${itemKey.split('.').reduce((obj, k) => obj?.[k], item) ?? `${item.category}-${index}`}-${index}`}
          >
            <ItemComponent
              data={item}
              onDelete={handleItemDelete}
              adminMode={adminMode}
              readOnly={readOnly}
            />
            <Divider sx={{ borderColor: theme.palette.grey.line }} />
          </React.Fragment>
        ))}
        {totalCount === 0 && !loading && <NoData />}
      </Stack>

      {/* 페이지네이션 */}
      {pageCount > 1 && <Pagination count={pageCount} page={page} onChange={handlePageChange} />}
    </ProgressBar>
  );
};

export default ActivityTab;
